export function getResultsPage(items, page, perPage) {
    const start = (page - 1) * perPage;
    const end = page * perPage;
    return items.slice(start, end);
}

export function filterItems(items, filters) {
    let matchingItems = [...items];

    function includesIgnoreCase(fieldValue, filterValue) {
        return String(fieldValue ?? '').toUpperCase().includes(String(filterValue).toUpperCase());
    }

    for (const [key, value] of Object.entries(filters)) {
        if (!value) {
            continue;
        }

        if (Number.isInteger(Number(key))) {
            matchingItems = matchingItems.filter((item) => {
                return includesIgnoreCase(item.history?.[key], value);
            });
        } else {
            matchingItems = matchingItems.filter((item) => {
                return includesIgnoreCase(item[key], value);
            });
        }
    }

    return matchingItems;
}
